import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  TextInput,
  TextField,
  EditButton,
  BulkDeleteButton,
  DeleteButton,
  FunctionField,
  DateField,
} from "react-admin";
import { VideoTypeSelectInput } from "../../UI/Input/SelectInput";
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />

  </Filter>
);
const ListActionButtons = ({ ...props }) => {
  return (
    <>
      <BulkDeleteButton
        {...props}
        undoable={false}
        confirmTitle="Delete File Record"
        confirmContent={"Are you sure you want to delete this record?"}
      />
    </>
  );
};
const MarketResearchCustomizationList = ({ ...props }) => {
  return (
    <List
      {...props}
      title="Basic Plan"
      bulkActionButtons={<ListActionButtons />}
      filters={<ListFilter />}

    >
      <Datagrid rowClick={"show"}>
        <TextField source="id" />
        <TextField source="title" label="Title" />
        <TextField source="accept" label="Accept" />
        <TextField source="description1" label="Description1" />
        <TextField source="description2" label="Description2" />
        <TextField source="field1" label="Field1" />
        <TextField source="field2" label="Field2" />
        <TextField source="field3" label="Field3" />
        <TextField source="field4" label="Field4" />
        <TextField source="field5" label="Field5" />

      

        {useCheckPermissions("MarketResearch_View") ? <EditButton /> : null}
       
      </Datagrid>
    </List>
  );
};

export default MarketResearchCustomizationList;
